export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "cs": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pomozte zlepšit Central!"])},
        "introduction": [
          {
            "full": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Na kartě ", _interpolate(_named("usageReporting")), " v Nastavení systému můžete zvolit sdílení anonymizovaných údajů o používání nebo kontaktních informací s týmem Central."])},
            "usageReporting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hlášení o použití"])}
          },
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tam můžete také zvolit, že se tato zpráva již nebude zobrazovat."])},
          
        ],
        "action": {
          "improveCentral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zlepšit Central"])}
        }
      },
      "de": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hilf ODK Central zu verbessern!"])},
        "introduction": [
          {
            "full": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Unter ", _interpolate(_named("usageReporting")), " in den Systemeinstellungen kannst du wählen, ob duanonymisierte Nutzungsdaten oder Kontaktinformationen mit dem Central-Team teilen möchtest."])},
            "usageReporting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsberichterstattung"])}
          },
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dort können Sie auch festlegen, dass diese Nachricht nicht mehr angezeigt wird."])},
          
        ],
        "action": {
          "improveCentral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verbessere Central"])}
        }
      },
      "es": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ayuda a mejorar Central"])},
        "introduction": [
          {
            "full": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["En la pestaña ", _interpolate(_named("usageReporting")), " en Configuración del sistema, puede optar por compartir datos de uso anónimos o información de contacto con el equipo Central."])},
            "usageReporting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informes de uso"])}
          },
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allí, también puede optar por no volver a ver este mensaje."])},
          
        ],
        "action": {
          "improveCentral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mejorar Central"])}
        }
      },
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aidez à améliorer Central !"])},
        "introduction": [
          {
            "full": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Dans l'onglet ", _interpolate(_named("usageReporting")), " des Paramètres Système, vous pouvez choisir de partager des données d'usage anonymisées ou vos coordonnées avec l'équipe de Central."])},
            "usageReporting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapports d'utilisation"])}
          },
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Là, vous pouvez également choisir de ne plus voir à nouveau ce message."])},
          
        ],
        "action": {
          "improveCentral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Améliorer Central"])}
        }
      },
      "it": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aiuta a migliorare Central"])},
        "introduction": [
          {
            "full": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Nella scheda ", _interpolate(_named("usageReporting")), " in Impostazioni di sistema, puoi scegliere di condividere dati di utilizzo anonimi o informazioni di contatto con il team Central."])},
            "usageReporting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report di utilizzo"])}
          },
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lì, puoi anche scegliere di non vedere più questo messaggio."])},
          
        ],
        "action": {
          "improveCentral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Migliora Central"])}
        }
      },
      "ja": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Centralの改善に貢献"])},
        "introduction": [
          {
            "full": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["システム管理の", _interpolate(_named("usageReporting")), "タブで、あなたは匿名の利用データを共有するか、あなたのコンタクトをCentralの開発チームと共有するかを選択できます。"])},
            "usageReporting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["利用状況報告"])}
          },
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["そこで、あなたはこのメッセージを再び表示しないように設定できます。"])},
          
        ],
        "action": {
          "improveCentral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Centralを改善する。"])}
        }
      },
      "sw": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saidia Kuboresha Central!"])},
        "introduction": [
          {
            "full": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Katika kichupo cha ", _interpolate(_named("usageReporting")), " katika Mipangilio ya Mfumo, unaweza kuchagua kushiriki data ya matumizi isiyojulikana au maelezo ya mawasiliano na timu ya Kati."])},
            "usageReporting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ripoti ya Matumizi"])}
          },
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Huko, unaweza pia kuchagua kutouona ujumbe huu tena"])},
          
        ],
        "action": {
          "improveCentral": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boresha Central"])}
        }
      }
    }
  })
}
